import * as React from 'react'
import {
  StatusMessage
} from '../UWPNotifier/inputActions'
import { StringMap } from 'DVWebNodeUtils'
import * as st from './DownloadStatusMessages.module.scss'

interface DownloadStatusMessageProps {
  messages: StatusMessage[]
  strings: StringMap
}

export const DownloadStatusMessages = ({ messages, strings }: DownloadStatusMessageProps) => (
  <>
    {messages.map((message, i) => (
      <div key={`status-message-${i}`} className={st.statusMessage}>
        <span>{message.localization === 'id' ? strings[message.message]: message.message}</span>
        <span className={st.errorCode}>{message.code}</span>
      </div>
    ))}
  </>
)